import HttpClient from '../services/HttpClient'
import axios from 'axios'

const noTokenAxiosClient = axios.create()

function handleError(error) {
   if (typeof error?.response === 'undefined') {
      // Error de red: CORS o conexión caída
      return Promise.reject(error)
   }
   return Promise.reject(error?.response)
}

export function getFromApiWithoutToken(url) {
   return noTokenAxiosClient
      .get(url)
      .then(response => response.data)
      .catch(handleError)
}

export function postToApiWithoutToken(url, payload) {
   return noTokenAxiosClient
      .post(url, payload)
      .then(response => response.data)
      .catch(handleError)
}

export const getBlobFromApi = (url, params) => {
   return HttpClient.get(url, { params, responseType: 'blob' })
      .then(response => response.data)
      .catch(handleError)
}

export const getFromApi = (url, params) => {
   return HttpClient.get(url, { params })
      .then(response => response.data)
      .catch(handleError)
}

export const postToApi = (url, payload) => {
   return HttpClient.post(url, payload)
      .then(response => response.data)
      .catch(handleError)
}

export const putToApi = (url, payload) => {
   return HttpClient.put(url, payload)
      .then(response => response.data)
      .catch(handleError)
}

export const patchToApi = (url, payload) => {
   return HttpClient.patch(url, payload)
      .then(response => response.data)
      .catch(handleError)
}

export const deleteToApi = url => {
   return HttpClient.delete(url)
      .then(response => response.data)
      .catch(handleError)
}

export const deleteToApiData = (url, data) => {
   return HttpClient.deleteData(url, { data })
      .then(response => response.data)
      .catch(handleError)
}

export const postToApiFile = (url, payload) => {
   return HttpClient.post(url, payload, {
      headers: {
         'Content-Type': 'multipart/form-data'
      }
   })
      .then(response => response.data)
      .catch(handleError)
}

export const postFromApi = (url, params) => {
   return HttpClient.post(url, { params })
      .then(response => response.data)
      .catch(handleError)
}
